<script setup lang="ts">
import { computed } from "vue";
import {
  CHAPTER_PATTERNS,
  CHAPTER_NUMBER_STYLES,
  normalizeChapterNumbering,
} from "../lib/chapterNumbering";
import type { ZwChapterNumbering } from "../lib/zwConfig";
import { just, nothing } from "../lib/maybe";
import ZwFieldRow from "./ui/ZwFieldRow.vue";
import ZwSelect from "./ui/ZwSelect.vue";
import ZwCheckbox from "./ui/ZwCheckbox.vue";
defineProps<{ kind: "Chapter" | "Act" }>();
const model = defineModel<ZwChapterNumbering>({ required: true });
const pattern = computed({
  get: () => model.value.pattern,
  set: (pattern: string) => {
    model.value = normalizeChapterNumbering({ ...model.value, pattern });
  },
});
const style = computed({
  get: () => model.value.style,
  set: (style: string) => {
    model.value = normalizeChapterNumbering({ ...model.value, style });
  },
});
const prefix = computed({
  get: () => model.value.prefix,
  set: (prefix: boolean) => {
    model.value = { ...model.value, prefix };
  },
});
</script>
<template>
  <ZwFieldRow class="chapter-numbering-row">
    <ZwSelect
      :id="nothing"
      v-model="pattern"
      :label="just('Heading pattern')"
      :options="just([...CHAPTER_PATTERNS])"
    />
    <ZwSelect
      v-if="pattern !== 'name'"
      :id="nothing"
      v-model="style"
      :label="just('Number style')"
      :options="just([...CHAPTER_NUMBER_STYLES])"
    />
  </ZwFieldRow>
  <ZwCheckbox v-if="pattern !== 'name'" v-model="prefix"
    >Include “{{ kind }}” before the number</ZwCheckbox
  >
</template>
